import * as React from 'react';
import { ComponentProps } from 'ui';
import styles from './section-summary.scss';
import { Label } from 'ui';

 /**
  * Renders a simplified non-connect'ed component for each child, with the purpose of re-using the configured
  * domain type and domain attributes for each child when displaying the summary.
  */
export const SectionSummary: React.FC<ComponentProps> = (props) => {
  const {
    className, 
    label, 
    componentId,
    children
  } = props;
  
  const contents = React.Children.map(children, (child) => {
                        return <li>{child}</li>;
  });

  return (
    contents && contents.length ?
      <div id={componentId} className={className}>
        <div className={styles.sectionSummary}>
          {label && label.visible && 
            <h3><Label label={props.label}/></h3>}
          <ul>{contents}</ul>
        </div>
      </div>
    : null);
};
